(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/secondary-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/secondary-button.js');
"use strict";


const Button = svs.ui.Button;
const SecondaryButton = _ref => {
  let children = _ref.children,
    onClick = _ref.onClick,
    transparent = _ref.transparent,
    disabled = _ref.disabled,
    className = _ref.className;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    inverted: !transparent,
    onClick: onClick,
    transparent: transparent
  }, children);
};
svs.tur.ReactPayfooter.SecondaryButton = SecondaryButton;

 })(window);